<template>
    <base-tool
        :tool-name="tool.name"
        :tool-description="tool.description"
        @back="goBack"
    >
        <div class="d-flex flex-column">
            <el-input
                class="mb-2"
                type="textarea"
                placeholder="Enter your message here"
                v-model="message"
                :rows="4"
                ref="messageInput"
                @focus="onMessageFocus"
                @blur="onMessageBlur"
            />

            <div class="d-flex align-items-center">
                <el-tooltip content="Add variable" placement="top">
                    <variables @variable-selected="variableSelected"/>
                </el-tooltip>

                <el-button
                    type="primary"
                    class="ml-auto"
                    @click="addSms"
                    :disabled="!isValidMessage"
                >
                    Add SMS
                </el-button>
            </div>
        </div>
    </base-tool>
</template>

<script>
import BaseTool from './base-tool.vue'
import ToolMixin from './tool-mixin'
import Variables from '../../../messenger/variables.vue'

export default {
    name: 'SendSmsTool',

    mixins: [ToolMixin],

    components: {
        BaseTool,
        Variables
    },

    props: {
        tool: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            message: '',
            cursorPosition: 0
        }
    },

    computed: {
        isValidMessage() {
            return this.message && this.message.trim() !== ''
        }
    },

    methods: {
        addSms() {
            if (!this.isValidMessage){
                return
            }

            // Trim the message to remove leading/trailing whitespace
            // and replace any newlines with spaces to prevent breaking the function pattern
            let trimmedMessage = this.message.trim()
            trimmedMessage = trimmedMessage.replace(/[\r\n]+/g, ' ')
            this.$emit('send-sms-selected', trimmedMessage)
        },

        variableSelected(variable) {
            let content = this.message
            content = content.slice(0, this.cursorPosition) + variable + content.slice(this.cursorPosition)
            this.cursorPosition = this.cursorPosition + variable.length
            this.message = content

            // Focus back on the message input
            this.$nextTick(() => {
                const input = this.$refs.messageInput.$el.querySelector('textarea')
                if (input) {
                    input.focus()
                    input.setSelectionRange(this.cursorPosition, this.cursorPosition)
                }
            })
        },

        onMessageFocus() {
            const input = this.$refs.messageInput.$el.querySelector('textarea')
            if (input) {
                this.cursorPosition = input.selectionStart
                input.addEventListener('click', this.updateCursorPosition)
                input.addEventListener('keyup', this.updateCursorPosition)
                input.addEventListener('keydown', this.onKeyDown)
            }
        },

        onMessageBlur() {
            const input = this.$refs.messageInput.$el.querySelector('textarea')
            if (input) {
                input.removeEventListener('click', this.updateCursorPosition)
                input.removeEventListener('keyup', this.updateCursorPosition)
                input.removeEventListener('keydown', this.onKeyDown)
            }
        },

        updateCursorPosition() {
            const input = this.$refs.messageInput.$el.querySelector('textarea')
            if (input) {
                this.cursorPosition = input.selectionStart
            }
        },
        
        onKeyDown(event) {
            // Handle backspace to remove entire variables
            if (event.key === 'Backspace') {
                if (this.removeVariable(event)) {
                    event.preventDefault()
                }
            }
        },

        removeVariable(event) {
            const content = this.message
            const cursorPos = this.cursorPosition

            // Look for variables like [customer_name], [phone], etc.
            const varRegex = /\[\w+\]/g
            let match

            // Find variables near cursor position
            while ((match = varRegex.exec(content)) !== null) {
                const varStart = match.index
                const varEnd = varStart + match[0].length
                
                // If cursor is at the end of or within a variable
                if (cursorPos > varStart && cursorPos <= varEnd) {
                    // Remove the entire variable
                    this.message = content.slice(0, varStart) + content.slice(varEnd)
                    this.$nextTick(() => {
                        const input = this.$refs.messageInput.$el.querySelector('textarea')
                        if (input) {
                            input.selectionStart = varStart
                            input.selectionEnd = varStart
                            this.cursorPosition = varStart
                        }
                    })
                    return true
                }
            }

            return false
        }
    }
}
</script>
